import SubscribeForm from "@/components/feature/SubscribeForm";

export default function SubscribeSection() {
  return (
    <section id="subscribe" className="bg-primary-950 py-14 md:py-16">
      <div className="container-editorial">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 rounded-full border border-accent-500/40 bg-accent-500/10 px-3.5 py-1.5 text-xs font-medium text-accent-300">
              <i className="ri-notification-3-line text-sm" />
              订阅独家爆料
            </span>
            <h2 className="mt-5 font-heading text-2xl font-black tracking-tight text-background-50 md:text-3xl">
              新料一出，第一时间送到你邮箱
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-100/70 md:text-base">
              不刷屏、不做无意义推送。只在你关注的方向出现值得跟进的线索时通知你，随时可以退订。
            </p>
            <ul className="mt-6 space-y-2.5">
              {["按关注方向定向推送", "重大进展即时提醒", "不转发、不营销，仅用于爆料更新"].map((item) => (
                <li key={item} className="flex items-center gap-2.5 text-sm text-background-100/75">
                  <span className="flex h-5 w-5 items-center justify-center rounded-full bg-accent-500/20 text-accent-300">
                    <i className="ri-check-line text-xs" />
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-7">
            <SubscribeForm />
          </div>
        </div>
      </div>
    </section>
  );
}